import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  accordionDetails: {
    display: "block",
    padding: 0,
    backgroundColor: "#f3f3f3"
  }
}));
